import { IonRefresher, IonRefresherContent, RefresherEventDetail } from '@ionic/react'

interface IProps {
  loading: boolean
  callback: () => void
  style?: any
}

export const PullRefresh = ({ loading, callback, style }: IProps) => {
  const handleRefresh = async (event: CustomEvent<RefresherEventDetail>) => {
    if (!loading) {
      await callback()
    }
    setTimeout(() => {
      event.detail.complete()
    }, 400)
  }

  return (
    <div className='relative'>
      <IonRefresher
        mode='md'
        onIonRefresh={(e) => handleRefresh(e)}
        slot='fixed'
        style={{
          ...(style || {})
        }}
      >
        <IonRefresherContent pullingIcon='circular' refreshingSpinner='circular' />
      </IonRefresher>
    </div>
  )
}
